/**
 * Tenant API routes
 */
import API_ROUTES_V2 from "~/api-routes-v2";

export const TenantRoutes = {
  createTenant: API_ROUTES_V2.CREATE_TENANT,
  verifyDomain: API_ROUTES_V2.VERIFY_DOMAIN,
  listTenants: API_ROUTES_V2.LIST_TENANTS,
} as const;
